import "./styles.css";


function Publish() {

    return (
        <div className="publish">
            <div className="publish-content">
                Publish go here
            </div>

        </div>
    )
}

export default Publish;